import { render, staticRenderFns } from "./OtherPrescription.vue?vue&type=template&id=32a4e17a&scoped=true&"
import script from "./OtherPrescription.vue?vue&type=script&lang=js&"
export * from "./OtherPrescription.vue?vue&type=script&lang=js&"
import style0 from "./OtherPrescription.vue?vue&type=style&index=0&id=32a4e17a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4e17a",
  null
  
)

export default component.exports